// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1AbvN","log":"ModalInventoryLogs_log__2yPUm","date":"ModalInventoryLogs_date__2kIli","userName":"ModalInventoryLogs_userName__yGIDt"};